import { IArticle } from '../../pages/KBBrands/KBBrandsTypes';

export interface IGoalTrackerRegistration {
  id: number;
  goal_tracker_id: number;
  user_id: number;
  status: number;
  created_at: string;
  updated_at: string;
}

export interface IGoal {
  id: number;
  amount: number;
  reward: number;
  user_id: number;
  goal_tracker_id: number;
  created_at: string;
  status: number;
  metadata: null;
  isActive?: boolean;
  nextGoalReward?: number | null;
  isLastGoal?: boolean;
}

export interface IGoalTracker {
  id: number;
  user_id: number;
  progress: number;
  date_start: null;
  date_end: string;
  created_at: string;
  status: number;
  metadata: null;
  goals: IGoal[];
}

export enum GoalStatus {
  ACTIVE = 1,
  REWARDED = 2,
  COMPLETED = 3,
}

export interface IGoalTrackerForCardReward {
  id: number;
  title: string;
  background_image: string;
  main_activity_banner?: string;
  product_range_banner?: string;
  background_color: string;
  date_start?: string;
  date_end?: string;
  registration_deadline?: string;
  registration_fee?: number;
  mechanics?: string;
  reward_text?: string;
  terms_and_conditions?: string;
  baseline_target_name: string;
  baseline_reward_name: string;
  step_reward_name: string;
  ceiling_reward_name: string;
  baseline_target: number;
  baseline_reward: number;
  step_reward: number;
  ceiling_reward: number;
  status: number;
  registration?: IGoalTrackerRegistration | null;
  display_status?: 'not_registered' | 'registered' | 'expired' | 'completed';
  goal_progress?: IGoalTrackerProgressCard | null;
  article?: IArticle;
}

export interface IGoalTrackerProgressCard {
  id: number;
  user_id: number;
  goal_tracker_id: number;
  progress_date: string;
  target: number;
  result: number;
  reward: number;
  rating: number;
  message?: string | null;
  created_at: string;
}
export interface IGoalTrackerForCardRewardResponse {
  data: IGoalTrackerForCardReward[];
  status: number;
}

export interface IRewardSteps {
  label: string;
  value: number | null;
}
